var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNnLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 696.1 560",
    enableBackground: "new 0 0 696.1 560",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00ACC8",
    d: "M573.8,381.5V136.7h-47.5V343L372.5,136.7h-47.6V343L189.5,161.3c4.3-7.2,6.7-15.6,6.7-24.6 c0-26.8-21.7-48.6-48.5-48.6c-26.8,0-48.6,21.8-48.6,48.6c0,17.9,9.8,33.6,24.3,42v245H172V217.8l152.9,205.9h47.6V217.8 l135.6,181.5c-4.1,7.1-6.6,15.6-6.6,24.4c0,26.8,21.8,48.6,48.6,48.6c26.8,0,48.5-21.8,48.5-48.6 C598.7,405.6,588.7,389.8,573.8,381.5 M147.7,113c13.1,0,23.8,10.6,23.8,23.8v0.4c0,1.2-0.2,2.4-0.4,3.5 c-1.9,11.3-11.6,19.7-23.4,19.7c-13.1,0-23.8-10.6-23.8-23.7C123.9,123.6,134.6,113,147.7,113 M550.1,447.6 c-13.1,0-23.8-10.7-23.8-23.8c0-13.1,10.7-23.8,23.8-23.8c13.1,0,23.7,10.7,23.7,23.8C573.8,436.9,563.2,447.6,550.1,447.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNnLogo);
export default __webpack_public_path__ + "static/media/NN_logo.38efd8a34a0bbce29af4fdb7f4dd72a4.svg";
export { ForwardRef as ReactComponent };